//* Styles
import ServiceItemStyle from './style';

//* Components
import Text from '@/components/Text';
import Icon from '@/components/Icon';

const ServiceItem = ({ className, name, tag }) => {
	return (
		<ServiceItemStyle className={className || ''}>
			<Icon
				className={'icon'}
				name={'arrowMarker'}
			/>
			<div className='wrapper-icon-title'>
				<Text className={'font-montserrat-arm-medium h6 text-primary-color'}>{name}</Text>

				{tag && (
					<div className={'tag-wrapper-outside'}>
						{tag.map((item, index) => {
							return (
								<div
									key={index}
									style={{ '--delayTag': index }}
									className={'tag-wrapper'}>
									<Icon
										className={'check-icon'}
										name={'check'}
									/>

									<Text className={'p2 text-primary-color tag-text first-letter'}>{item}</Text>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</ServiceItemStyle>
	);
};

export default ServiceItem;
